<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Moduler</h1>
  </div>
  <div class="comp-header__queries">
    <adm-text-search placeholder="Indtast navn" (search$)="querySearchInput($event)" [searchText]="state.filters().query ?? ''" />
  </div>
</div>

<div class="comp-main">
  <adm-loading-spinner [loadingSignal]="state.loading()" [noResultsMessage]="'Noget gik galt, da der blev forsøgt at hente moduler'" />
  @if (data(); as currentData) {
    @if ((appState.isInErrorState$ | async) === false) {
      <div class="list" [class.loading-blur]="state.loading()" [class.loading-blur--done]="!state.loading()">
        <table class="matrix-table table" matSort (matSortChange)="sortData($event)">
          <thead>
            <tr>
              <th class="matrix-table__organization" mat-sort-header="name">Organisation</th>
              <th class="matrix-table__org-type" mat-sort-header="type">Type</th>
              @for (module of currentData.modules; track module.id) {
                <th class="matrix-table__module">
                  <div class="matrix-table__module-header">
                    <span>{{ module.name }}</span>
                    <button
                      mat-icon-button="mat-icon-button"
                      [matMenuTriggerFor]="menu"
                      aria-label="Example icon-button with a menu"
                      [matTooltip]="'Ændre modul tilknytning'"
                      [admRequiresFeatureRole]="roles['module.write'] ?? ''">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                  </div>
                  <mat-menu #menu="matMenu">
                    <button
                      mat-menu-item="mat-menu-item"
                      (click)="removeModuleFromOrganizations(module.id)"
                      [admRequiresFeatureRole]="roles['module.write'] ?? ''">
                      <span>Deaktiver modul på alle organisationer</span>
                    </button>
                    <button
                      mat-menu-item="mat-menu-item"
                      (click)="addModuleToOrganizations(module.id)"
                      [admRequiresFeatureRole]="roles['module.write'] ?? ''">
                      <span>Aktiver modul på alle organisationer</span>
                    </button>
                    <button
                      mat-menu-item="mat-menu-item"
                      [matMenuTriggerFor]="organizationTypesMenu"
                      [admRequiresFeatureRole]="roles['module.write'] ?? ''">
                      <span>Aktiver modul ved organisationstype</span>
                    </button>
                  </mat-menu>
                  <mat-menu #organizationTypesMenu="matMenu">
                    @for (enum of organizationType | keyvalue; track enum.key) {
                      <button mat-menu-item="mat-menu-item" (click)="addModuleToOrganizations(module.id, enum.key)">
                        {{ enum.key | translateOrganizationType }}
                      </button>
                    }
                  </mat-menu>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @if (data(); as currentData) {
              @for (moduleMatrixRow of currentData.moduleMatrixRows; track moduleMatrixRow.organizationId) {
                <tr>
                  <td class="matrix-table__organization">{{ moduleMatrixRow.organizationName }}</td>
                  <td class="matrix-table__org-type">
                    {{ moduleMatrixRow.organizationType | translateOrganizationType }}
                  </td>
                  @for (module of moduleMatrixRow.modules; track module.module.id) {
                    <td class="matrix-table__module">
                      @if ((module.updating | async) === false) {
                        <mat-slide-toggle
                          [(ngModel)]="module.organizationHasModule"
                          color="primary"
                          (ngModelChange)="updateMatrix(moduleMatrixRow, module)"
                          [disabled]="!this.authService.hasRole(this.roles[Permission.ModuleWrite])" />
                      } @else {
                        <mat-spinner style="margin: 0 auto" color="primary" diameter="20"></mat-spinner>
                      }
                    </td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    }
  }
  @if ((data()?.modules?.length ?? 0) === 0 && !state.loading()) {
    <div class="no-results align-center">
      <p>Der blev ikke fundet nogen moduler</p>
    </div>
  }
</div>
<mat-paginator
  #paginator
  class="paginator"
  [style.visibility]="(data()?.moduleMatrixRows?.length ?? 0) === 0 ? 'hidden' : 'visible'"
  [pageIndex]="state.filters().page.pageIndex"
  [pageSize]="state.filters().page.pageSize"
  [pageSizeOptions]="state.pagingOptions()"
  [length]="data()?.totalCount || 0"
  (page)="pageSwitch($event)"
  color="accent"
  [disabled]="state.loading()" />
